var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropper"},[_c('input',{attrs:{"type":"file","multiple":"","accept":"image/*"},on:{"change":function($event){return _vm.uploadImages($event.target.files)}}}),_c('span',[_vm._v(" Drag Files Here!")])])}
var staticRenderFns = []

export { render, staticRenderFns }